import React, { Component } from 'react';
import { /*Badge, DropdownItem, DropdownMenu, DropdownToggle,*/ Nav, NavItem, NavLink } from 'reactstrap';
import PropTypes from 'prop-types';

import { AppHeaderDropdown, AppNavbarBrand, AppSidebarToggler } from '@coreui/react';
import logo from '../../assets/img/brand/wenatives.svg'
import sygnet from '../../assets/img/brand/sygnet.svg'

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultHeader extends Component {
  render() {

    // eslint-disable-next-line
    const { children, ...attributes } = this.props;

    return (
      <React.Fragment>
        <AppSidebarToggler className="d-lg-none" display="md" mobile />
        <AppNavbarBrand
          full={{ src: logo, width: 130, height: 35, alt: 'Logo' }}
          minimized={{ src: sygnet, width: 30, height: 30, alt: 'Papas' }}
        />
        <AppSidebarToggler className="d-md-down-none" display="lg" />

        <h3>{this.props.user}</h3>
        <Nav className="ml-auto" navbar>
          <AppHeaderDropdown direction="down">

          </AppHeaderDropdown>
        </Nav>
      </React.Fragment>
    );
  }
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

export default DefaultHeader;
